import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faDocker,
} from "@fortawesome/free-brands-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";

const labelsFirst = [
  "React",
  "Next.js",
  "Vue.js",
  "TypeScript",
  "JavaScript",
  "Node.js",
  "Go",
  "Python",
  "HTML5",
  "CSS3",
  "SASS",
];

const labelsSecond = [
  "Git",
  "GitHub Actions",
  "CI/CD",
  "Docker",
  "AWS",
  "Terraform",
  "Cypress",
  "Jest",
  "Sentry",
  "Datadog",
];

const labelsThird = [
  "Snowflake",
  "SQL",
  "Data Integration",
  "APIs",
  "Observability",
  "SLOs",
  "Telemetry",
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Highlights</h1>
        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Full-Stack Web Development</h3>
            <p>
              I build reliable, scalable web applications end-to-end using
              modern frameworks. From performant UIs to well-structured
              backends, I drive features from concept to production with a
              strong grasp of the SDLC.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFirst.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDocker} size="3x" />
            <h3>DevOps & Quality Engineering</h3>
            <p>
              I set up testing, CI/CD pipelines, and deployment automation to
              ship confidently and often—adding monitoring, alerting, and
              error-tracking to keep systems healthy post-launch.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsSecond.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDatabase} size="3x" />
            <h3>Data & Cloud Platforms</h3>
            <p>
              I work across data-centric platforms and cloud services—integrating
              datasets, optimizing APIs and performance paths, and improving
              reliability with observability, SLOs, and telemetry.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsThird.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
